import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarRegularReportIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.9 22.3q1 .1 1.1 1v3.8q-.1 1-1.1 1.1H18q-1-.1-1.1-1V23l.2-.3.1-.1.2-.1.6-.2zm4.5-4.6h.3v.1h.1q.6.4.7 1v8.5q-.2.9-1.1 1h-.8q-1-.2-1.1-1.2V19a1 1 0 0 1 1.1-1.1zm4.5 1.6q1 .1 1.1 1v6.8q-.1 1-1.1 1.1H27q-1-.1-1.1-1v-6.8q.1-1 1.1-1.1zM16 1.6q.8 0 1 .7l3.7 7.2 8 1.2a1.2 1.2 0 0 1 .7 2l-3.9 4q-.8-1-2.1-1H23l3-3-6.2-1q-.6 0-1-.6L16 5.4l-2.9 5.7q-.3.5-.9.6l-6.2 1 4.4 4.5q.4.5.4 1l-1 6.3 5.7-2.8q-.5.6-.5 1.7v1.2l-6.2 3.1A1.2 1.2 0 0 1 7 26.6l1.2-8-5.7-5.7a1.2 1.2 0 0 1 .7-2l8-1.3 3.6-7.2q.4-.6 1.1-.7m0 0" })
});
export default SvgStarRegularReportIcon;
